import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "CommonHtmlEditorViewContainer wd100 pd12 box"
};
const _hoisted_2 = {
  class: "ft30 boldFont"
};
const _hoisted_3 = {
  class: "bothCenter wd100 mt12"
};
const _hoisted_4 = {
  ref: "aiEditor",
  class: "wbg pd12 box wd100",
  style: {
    "height": "calc(100vh - 78px)",
    "width": "850px"
  }
};
const _hoisted_5 = {
  class: "leftCenter"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_popconfirm = _resolveComponent("el-popconfirm");
  const _component_el_timeline_item = _resolveComponent("el-timeline-item");
  const _component_el_timeline = _resolveComponent("el-timeline");
  const _component_el_drawer = _resolveComponent("el-drawer");
  const _component_CommonHtmlPreviewView = _resolveComponent("CommonHtmlPreviewView");
  const _component_DialogCustomView = _resolveComponent("DialogCustomView");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "bothCenter"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 3,
      class: "bothCenter"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_button, {
        style: {
          "width": "100px"
        },
        onClick: _cache[0] || (_cache[0] = $event => $data.drawer = true)
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("历史版本")])),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 18,
      class: "bothCenter"
    }, {
      default: _withCtx(() => [_createElementVNode("span", _hoisted_2, _toDisplayString($data.title), 1)]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 3,
      class: "rightCenter"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_button, {
        type: "primary",
        style: {
          "width": "100px"
        },
        onClick: _cache[1] || (_cache[1] = $event => $options.save(false))
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("保存 SAVE")])),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  }), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, null, 512)])]), _createVNode(_component_el_drawer, {
    direction: "ltr",
    modelValue: $data.drawer,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.drawer = $event),
    title: "版本历史"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_timeline, {
      reverse: _ctx.reverse
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.versions, (activity, index) => {
        return _openBlock(), _createBlock(_component_el_timeline_item, {
          key: index,
          color: index > 0 ? 'lightgray' : '#67c23a',
          timestamp: activity.userName
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createElementVNode("span", null, _toDisplayString(activity.createdTime), 1), _createVNode(_component_el_button, {
            size: "small",
            type: "success",
            class: "ml12",
            onClick: $event => $options.previewHistory(activity.html)
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("预览")])),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_popconfirm, {
            title: "确定载入吗",
            onConfirm: $event => $options.loadHistoryToNow(activity.html)
          }, {
            reference: _withCtx(() => [_createVNode(_component_el_button, {
              size: "small",
              type: "warning"
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("载入")])),
              _: 1
            })]),
            _: 2
          }, 1032, ["onConfirm"])])]),
          _: 2
        }, 1032, ["color", "timestamp"]);
      }), 128))]),
      _: 1
    }, 8, ["reverse"])]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_DialogCustomView, {
    title: "历史版本预览",
    "visible-control": $data.historyPreview,
    width: "1000px",
    onClose: _cache[3] || (_cache[3] = $event => $data.historyPreview = false)
  }, {
    default: _withCtx(() => [$data.historyPreview ? (_openBlock(), _createBlock(_component_CommonHtmlPreviewView, {
      key: 0,
      "html-version": $data.htmlVersion
    }, null, 8, ["html-version"])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["visible-control"])], 64);
}